<!-- `p-drawer` direto: não há wrapper Vault de painel lateral. Z-index fixo 10300 (faixa das modais,
     src/styles/Z-INDEX.md), com `autoZIndex` desligado: o automático passava do toast (10500) e escondia o erro do
     Salvar. O fechar (X e Esc) é da gaveta, para perguntar antes de descartar mudança não salva. -->
<p-drawer
  [visible]="visible()"
  position="right"
  [modal]="true"
  [dismissible]="false"
  [closeOnEscape]="false"
  [closable]="false"
  [blockScroll]="true"
  [autoZIndex]="false"
  [maskStyle]="{ 'z-index': '10299' }"
  appendTo="body"
  styleClass="home-customize-drawer"
  [style]="{ width: '400px', maxWidth: '100vw', zIndex: '10300' }">
  <ng-template #header>
    <div class="home-customize__header">
      <div class="home-customize__title">
        <i class="pi pi-sliders-h" aria-hidden="true"></i>
        <span>Personalizar Dashboard</span>
      </div>
      <button
        type="button"
        class="home-customize__close"
        title="Fechar"
        aria-label="Fechar a gaveta Personalizar"
        (click)="requestClose()">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>
  </ng-template>

  <div class="home-customize">
    <p class="home-customize__intro">{{ intro() }}</p>

    <div
      class="home-customize__row home-customize__row--locked"
      aria-label="Busca do Cog: sempre no topo">
      <i class="pi pi-lock home-customize__lock" aria-hidden="true"></i>
      <span class="home-customize__label">Busca do Cog</span>
      <span class="home-customize__locked-hint">sempre no topo</span>
    </div>

    <div
      class="home-customize__list"
      cdkDropList
      cdkDropListLockAxis="y"
      [cdkDropListData]="rows()"
      (cdkDropListDropped)="drop($event)"
      aria-label="Blocos da Home">
      @for (row of rows(); track row.id; let index = $index) {
        <div
          class="home-customize__row"
          [class.home-customize__row--off]="!row.checkbox.isChecked"
          cdkDrag
          [cdkDragData]="row"
          cdkDragPreviewContainer="parent">
          <button
            type="button"
            class="home-customize__grip"
            cdkDragHandle
            title="Arraste para mudar a ordem"
            [attr.data-home-grip-id]="row.id"
            [attr.aria-label]="'Mover ' + row.label + ': use as setas para cima e para baixo'"
            (keydown)="gripKeydown($event, index)">
            <i class="pi pi-ellipsis-v" aria-hidden="true"></i>
            <i class="pi pi-ellipsis-v" aria-hidden="true"></i>
          </button>
          <div class="home-customize__body">
            <app-checkbox
              class="home-customize__checkbox"
              [checkbox]="row.checkbox"
              (sendCheckedChange)="toggle(row.id, $event)"></app-checkbox>
            @if (row.hint) {
              <small class="home-customize__hint">
                <i class="pi pi-info-circle" aria-hidden="true"></i>
                {{ row.hint }}
              </small>
            }
          </div>
          <div class="home-customize__slot" *cdkDragPlaceholder></div>
        </div>
      }
    </div>

    <span class="home-customize__sr-only" aria-live="polite">{{ liveMessage() }}</span>
  </div>

  <ng-template #footer>
    <div class="home-customize__footer">
      @if (saveError(); as message) {
        <app-simple-messages class="home-customize__error" severity="error" role="alert">
          {{ message }}
        </app-simple-messages>
      }
      <div class="home-customize__actions">
        <app-button
          class="home-customize__restore"
          icon="replay"
          theme="link"
          size="small"
          label="Restaurar Padrão"
          [noMargin]="true"
          [disabled]="saving()"
          (sendClick)="restoreDefault()"></app-button>
        <app-button
          class="home-customize__save"
          icon="check"
          theme="darkblue"
          size="small"
          label="Salvar"
          loadingText="Salvando..."
          [noMargin]="true"
          [isLoading]="saving()"
          [disabled]="!dirty()"
          [title]="dirty() ? '' : 'Nada mudou desde o último Salvar'"
          (sendClick)="save()"></app-button>
      </div>
    </div>
  </ng-template>
</p-drawer>
